<template>
    <transition name="el-fade-in-linear">
    <div v-show="transitionshow">
        <!------------------------search---------------------->
        <el-form :inline="true" class="backborder1 demo-form-inline" size="small">
            <el-form-item style="width:15%">
	            <el-select v-model="query.brandid" clearable filterable  placeholder="按品牌" @change="issearchchange=true">
	            	<el-option label="不分品牌" value="0"></el-option>
	                <el-option v-for="(item,index) in brandlists" :label="item.showlable" :value="item.id" :key="index">
	                	<span style="float: left">{{item.name}}</span>
      				    <span style="float: right; color: #C0C4CC; font-size: 13px">{{item.py}}</span>
	                </el-option>
	            </el-select>
            </el-form-item>
            <el-form-item>
	            <el-select v-model="query.warehouse" clearable placeholder="按仓库" style="width:150px;" @change="resetSearchParams">
	            	<el-option label="全部仓库" value="0"></el-option>
	              <el-option v-for="(item,index) in warehouselists" :label="item.name" :value="item.id" :key="index"></el-option>
	            </el-select>
            </el-form-item>
            <!--  -->
            <el-form-item v-if="goodsLocationStatus">
              <el-cascader
                :props="{ label: 'full_code', value: 'id', children: 'children' }"
                v-model="storage_location"
                :options="locationList"
                placeholder="请选择位置"
                clearable
                >
              </el-cascader>
            </el-form-item>
            <el-form-item ref="query" :model="query" v-if="goodsLocationStatus">
            	<el-input placeholder="请输入货位" v-model="query.storage_location_keyword" clearable @keyup.enter.native="getList" @change="issearchchange=true"></el-input>
            </el-form-item>
            <!--  -->
            <el-form-item ref="query" :model="query">
            	<el-input placeholder="请输入关键字" v-model="query.key" clearable @keyup.enter.native="getList" @change="issearchchange=true"></el-input>
            </el-form-item>
            <el-form-item>
           	    <el-button type="warning" icon="el-icon-search" @click="getList">查询</el-button>
                <el-button type="warning" icon="el-icon-download" @click="exportdata">导出</el-button>
                <el-tooltip class="item" effect="dark" content="查看冻结库存详情" placement="top">
                <el-button type="warning" icon="el-icon-view" @click="showfrozeninventory">冻结库存</el-button>
                </el-tooltip>
                <el-tooltip class="item" effect="dark" content="查询库存预售情况" placement="top">
                <el-button type="warning" icon="el-icon-view" @click="showsalefulture">库存预售查询</el-button>
                </el-tooltip>
                <el-button type="warning" icon="el-icon-upload" @click="$refs.inventoryListImportDiaologRef.openDialog()">导入商品货位关联</el-button>
            </el-form-item>
        </el-form>

        <!-- 导入商品货位关联弹窗 -->
        <inventoryListImportDiaolog ref="inventoryListImportDiaologRef" @upload="getList()" />

        <!------------------------search end---------------------->
        <div class="backborder2" style="margin-top:10px">
	        <el-table :data="lists" v-loading="listLoading">
              <el-table-column prop="id" label="id" width="100" align="center"></el-table-column>
	            <el-table-column label="商品信息" min-width="350">
                  <template slot-scope="scope">
                      <div class="cz-product-inventorys-main">
                          <div class="cz-product-inventorys-main-imgs">
                            <img :src="scope.row.thumb!='' ? scope.row.thumb : require('../../assets/img-default.png')" />
                          </div>
                          <div class="cz-product-inventorys-main-infos">
                              <div class="cz-product-inventorys-main-infos-name">{{scope.row.name}}</div>
                              <div class="cz-product-inventorys-main-infos-number">编号：{{scope.row.number}}</div>
                              <div class="cz-product-inventorys-main-infos-number">规格：{{scope.row.spec}}</div>
                          </div>
                      </div>
                  </template>
              </el-table-column>
              <el-table-column prop="box_gauge" label="箱装规格" width="130" align="center"></el-table-column>
	            <el-table-column label="品牌" width="180" align="center">
                  <template slot-scope="scope">
                    <div class="cz-product-inventorys">
                       <div class="cz-product-inventorys-value">{{scope.row.companyname ? scope.row.companyname : '-'}}</div>
                    </div>
	          	    </template>
              </el-table-column>
              <!--
              <el-table-column prop="buy" label="进货价" width="120" align="center"></el-table-column>
              -->
	            <el-table-column prop="sell" label="批发价" width="120" align="center"></el-table-column>
	            <el-table-column prop="market" label="零售价" width="120" align="center"></el-table-column>
              <el-table-column label="库存" width="120" align="center">
	            	  <template slot-scope="scope">
                    <div class="cz-product-inventorys">
                       <div class="cz-product-inventorys-value" :style="scope.row.isempty==0 ? 'color:#F56C6C' : '' ">{{scope.row.inventory}}</div>
                    </div>
	          	    </template>
	            </el-table-column>
              <el-table-column label="可用库存" width="120" align="center">
	            	  <template slot-scope="scope">
                    <div class="cz-product-inventorys">
                       <div class="cz-product-inventorys-value" :style="scope.row.isempty==0 ? 'color:#F56C6C' : '' ">{{scope.row.lastinventory}}</div>
                    </div>
	          	    </template>
	            </el-table-column>
              <el-table-column label="货位" width="225" align="center" v-if="goodsLocationStatus">
	            	  <template slot-scope="scope">
                    <div class="">
                       <div class="cz-product-inventorys-value" v-for="(locationItem,index) in scope.row.storage_location" :key="index">{{locationItem.full_code}} <span style="color: red;">（{{(locationItem.available_number)}}）</span>;</div>
                    </div>
	          	    </template>
	            </el-table-column>
              <el-table-column label="操作" width="250" align="center" fixed="right">
                  <template slot-scope="scope">
                    <div class="flex-warp">
                      <el-button round type="warning" size="mini" @click="checkinventorylogsnew(scope.row)">出入库记录</el-button>
                      <el-button round type="warning" size="mini" @click="getfrozeninventorys(scope.row)">查看库存明细</el-button>
                    </div>
                    <div class="flex-warp" style="margin-top: 5px;">
                      <el-button v-if="actionauth.batchRecord == 'true' && batchStatus" round type="warning" size="mini" @click="toWarning(scope.row)">批次记录</el-button>
                      <el-button v-if="storageLocationStatus"  round type="warning" size="mini" @click="$refs.inventoryListBindRef.openDialog(scope.row)">关联/清除货位</el-button>
                    </div>
                 </template>
              </el-table-column>
	        </el-table>
	        <div class="block">
	            <!--分页begin-->
	            <el-pagination
		            @size-change="pageSizeChange"
		            @current-change="pageCurrentChange"
		            :current-page="query.p"
		            :page-sizes="[10, 20, 50]"
		            :page-size="query.rollpage"
		            layout="total, sizes, prev, pager, next, jumper"
		            :total="total_rows">
	            </el-pagination>
	            <!--分页end-->
	        </div>
        </div>

        <!-- 关联货位开始 -->
        <inventoryListBind ref="inventoryListBindRef" :warehouselists="warehouselists" @refresh="getList()" />
        <!-- 关联货位结束 -->

        <!-- 入库记录和出库记录 -->
        <el-dialog :title="logname" :visible.sync="inputandsellDialog" top="5vh" width="85%">
            <el-col :span="24">
                <a class="allreport" href="javascript:;" @click="getallreport()">总报告</a>
            </el-col>
            <div class="inputs" style="margin-top:10px">
                <table cellspacing="0" cellpadding="0">
                    <tr>
                        <th align="center">入库数量</th>
                        <th align="center">出库数量</th>
                        <th align="center">剩余数量</th>
                        <th align="center">入库类型</th>
                        <th align="center">入库时间</th>
                        <th align="center">操作</th>
                    </tr>
                    <tr v-for="(item,index) in inputdatas" :key="index">
                        <td align="center">{{item.base_inventory}}</td>
                        <td align="center">{{item.sellinventory}}</td>
                        <td align="center">{{item.inventory}}</td>
                        <td align="center">{{item.type}}</td>
                        <td align="center">{{item.inputtime}}</td>
                        <td align="center">
                            <a class="report" href="javascript:;" @click="getsellslists(item)">出入明细</a>
                            <a class="report" href="javascript:;" @click="getreport(item)">报告</a>
                        </td>
                    </tr>
                </table>
                <div class="inputsmorelog"><a href="javascript:;" @click="getmoreinputsells">{{leftloadingname}}</a></div>
            </div>
            <div class="sells" style="margin-top:10px">
                <table cellspacing="0" cellpadding="0">
                    <tr>
                        <th align="center">出库数量</th>
                        <th align="center">出库时间</th>
                    </tr>
                    <tr v-for="(item,index) in sellslists" :key="index">
                        <td align="center">{{item.basenum}}</td>
                        <td align="center">{{item.inputtime}}</td>
                    </tr>
                </table>
                <div class="inputsmorelog"><a href="javascript:;" v-if="sellslists.length>0" @click="getmoresells">{{rightloadingname}}</a></div>
            </div>

            <div slot="footer" class="dialog-footer">
                <el-button size="medium" @click="inputandsellDialog = false" style="margin-top:20px">取 消</el-button>
            </div>
        </el-dialog>

        <!-- 入库、出库情况报告 -->
        <el-dialog title="入库、出库情况报告" :visible.sync="iasreportDialog" top="5vh" width="20%">
            <el-card class="box-card">
              <div class="text item">首次入库时间：  {{reportdatas.sinput}}</div>
              <div class="text item">最近入库时间：  {{reportdatas.einput}}</div>
              <div class="text item">累计入库数量：  {{reportdatas.inputbasenum}}</div>
              <div class="text item">剩余库存数量：  {{reportdatas.lastbasenum}}</div>
            </el-card>
            <el-card class="box-card" style="margin-top:10px">
              <div class="text item">首次出库时间：  {{reportdatas.ssell}}</div>
              <div class="text item">最近出库时间：  {{reportdatas.esell}}</div>
              <div class="text item">累计出库数量：  {{reportdatas.sellbasenum}}</div>
            </el-card>
            <div slot="footer" class="dialog-footer">
                <el-button size="medium" @click="iasreportDialog = false" >取 消</el-button>
            </div>
        </el-dialog>

        <!--------- 按客户导出信息 ------------>
        <el-dialog title="导出商品库存信息确认" :visible.sync="exportDialog" width="98%" top="5vh">
            <el-button size="medium" type="danger" @click="sureoutput" style="float:right;margin-right:0;margin-bottom:15px">确认导出</el-button>
            <div id="outputorder">
              <el-table :data="exportlists" border v-loading="exportloading">
                  <el-table-column prop="number" label="编号" width="100"></el-table-column>
                  <el-table-column prop="name" label="名称"></el-table-column>
                  <el-table-column prop="box_gauge" label="箱装规格" width="120" align="center"></el-table-column>
                  <el-table-column prop="basebarcode" label="条形码" width="100" align="center"></el-table-column>
                  <el-table-column prop="companyname" label="品牌" width="120"></el-table-column>
                  <el-table-column prop="spec" label="规格" width="100" align="center"></el-table-column>
                  <el-table-column prop="unit" label="单位" width="100" align="center"></el-table-column>
                  <el-table-column prop="sell" label="批发价" width="100" align="center"></el-table-column>
                  <el-table-column prop="market" label="零售价" width="100" align="center"></el-table-column>
                  <el-table-column label="库存" prop="inventory" width="100" align="center"></el-table-column>
                  <el-table-column label="可用库存" prop="lastinventory" width="100" align="center"></el-table-column>
                  <el-table-column label="货位" prop="storage_location_text" width="190" align="center" v-if="goodsLocationStatus">
                    <template slot-scope="scope">
                      <div v-html="scope.row.storage_location_text"></div>
                    </template>
                  </el-table-column>
              </el-table>
            </div>
            <div slot="footer" class="dialog-footer">
              <el-button size="medium" @click="exportDialog=false">取 消</el-button>
              <el-button size="medium" type="danger" @click="sureoutput">确认导出</el-button>
          </div>	                
        </el-dialog>


        <!-- 查看出入库记录 -->
        <el-dialog title="商品出入库记录" :visible.sync="inputsellquery.dialog" width="55%" top="5vh">
            <el-table :data="inputselllogs" v-loading="inputsellquery.loading">
                <el-table-column prop="documents" label="关联单号" align="left">
                    <template slot-scope="scope">
                      <span style="font-size:13px;">{{scope.row.documents}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="inventorys" label="数量" align="center">
                    <template slot-scope="scope">
                      <span :style="scope.row.inventorys > 0 ? 'font-size:13px;font-weight:550' : 'font-size:13px;font-weight:550;color:#f56c6c'  ">{{scope.row.inventorys}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="types" label="类型" align="center">
                    <template slot-scope="scope">
                      <span style="font-size:13px;">{{scope.row.types}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="inputtime" label="时间" align="center">
                    <template slot-scope="scope">
                      <span style="font-size:13px;">{{scope.row.inputtime}}</span>
                    </template>
                </el-table-column>
                <el-table-column v-if="batchStatus" label="操作" align="center">
                    <template slot-scope="scope">
                      <el-button type="text" @click="openBatch(scope.row)">查看批次效期</el-button>
                    </template>
                </el-table-column>
            </el-table>    
            <div class="block">
	            <!--分页begin-->
	            <el-pagination
		            @size-change="logspageSizeChange"
		            @current-change="logspageCurrentChange"
		            :current-page="inputsellquery.p"
		            :page-sizes="[10, 20, 50]"
		            :page-size="inputsellquery.rollpage"
		            layout="total, sizes, prev, pager, next, jumper"
		            :total="inputsellquery.row">
	            </el-pagination>
	            <!--分页end-->
	          </div>     
        </el-dialog>

        <!-- 查看批次效期开始 -->
        <el-dialog title="查看批次效期信息" :visible.sync="batchDialogVisible" width="50%" @close="batchData = []">
          <el-table :data="batchData" border>
            <el-table-column prop="batch_sn" label="批次号" align="center"></el-table-column>
            <el-table-column prop="start_date" label="生产日期" width="180" align="center"></el-table-column>
            <el-table-column prop="realvalidity" label="有效期" width="180" align="center">
              <template slot-scope="scope">
                <span>{{ scope.row.realvalidity }} {{ validityunitTemp[scope.row.validityunit] }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="end_date" label="到期日期" width="180" align="center"></el-table-column>
            <el-table-column prop="numbers" label="数量" width="100" align="center"></el-table-column>
          </el-table>
        </el-dialog>
        <!-- 查看批次效期结束 -->



  </div>
  </transition>
</template>

<script>
import inventoryListImportDiaolog from './inventoryListImportDiaolog.vue';
import inventoryListBind from './inventoryListBind.vue';
export default {
  components: { inventoryListImportDiaolog, inventoryListBind },
  data () {
    return {
      url:this.GLOBAL.domain+"Inventory/index",
      transitionshow:true,
      lists:[],
      brandlists:[],
      listLoading:false,
      actionauth:'',
      query:{
        act:'lists',
        token:this.$cookies.get('token'),
        brandid:'',
        key:'',
        rollpage: 10, // 页大小
        p: 1,
        storage_location:'',
        storage_location_keyword:''
      },
      total_rows: 0,
      categorylist:[],
      warehouselists:[],
      inputandsellDialog:false,
      inputsellquery:{
        act:'getinputselllogs',
        token:this.$cookies.get('token'),
        id:'',
        warehouse:'',
        rollpage: 10, // 页大小
        p: 1
      },
      logname:'',
      inputdatas:[],
      leftloadingname:'',
      issearchchange:false,

      sellsquery: {
          act:'getselllogs',
          token:this.$cookies.get('token'),
          inputid:'',
          rollpage: 10, // 页大小
          p: 1 
      },
      sellslists:[],
      rightloadingname:'',
      iasreportDialog:false,
      reportdatas:[],
      exportDialog:false,
      exportloading:false,
      exportlists:[],


      inputsellquery:{
        act:'getinputselllogs',
        token:this.$cookies.get('token'),
        id:'',
        p: 1,
        rollpage: 10, // 页大小
        loading:false,
        dialog:false,
        row:0
      },
      inputselllogs:[],
      locationList:[],
      storage_location:[],
      goodsLocationStatus:false,
      batchDialogVisible: false, // 控制批次效期对话框的显示状态
      batchData: [], // 存储批次效期表格数据
      validityunitTemp: { // 存储有效期单位
        1: '天',
        2: '月',
        3: '年'
      },
      batchStatus: false,
      storageLocationStatus: false
    }
  },
  mounted(){
    this.getBrand();
    this.getWarehouse();
    this.getList();
    this.checkLocationStatus()
    this.getactionauth(); //获取权限设置
    this.batchStatus = localStorage.getItem('batchStatus') === 'true'
    this.storageLocationStatus = localStorage.getItem('storageLocationStatus') === 'true'
  },
  methods:{
    /** 获取操作功能权限 **/
  	getactionauth() {
    	var data = this.$cookies.get('actionauth');
    	data = JSON.parse(data);
      this.actionauth = data;
      
    },
    toWarning(row) {
      // 编号
      const number = row.number

      this.$emit('listenchild',{ name:'保质期预警查询', url:'ShelfLifeWarning', data:{ number }});

    },
    openBatch(row) {
      this.batchDialogVisible = true; // 打开对话框
      const params = {
        act: 'see_batch_list',
        token: this.$cookies.get('token'),
        id: row.id,
        types: row.types,
      };
      const resource = this.$resource(this.GLOBAL.domain + 'Inventory/index');
      resource.query(params).then((res) => {
        if (res.data.Result > 0) {
          if (res.data.Result === '70001') this.$router.push('/login');
          this.$message.error(res.data.Message);
        } else {
          this.batchData = JSON.parse(Base64.decode(res.data.Data)); // 填充表格数据
          console.log(this.batchData, 'CHAKANICI')
        }
      }).catch((err) => {
        this.$message.error(this.GLOBAL.errortext);
      });
    },
    //获取新的入库记录列表
    checkinventorylogsnew(item) {
        this.inputsellquery.id=item.id;
        this.inputsellquery.p=1;
        this.inputsellquery.rollpage=10;
        this.inputsellquery.dialog=true;
        this.checkinventorylogdatas();
    },

    //加载新的入库记录数据
    checkinventorylogdatas() {
        this.inputsellquery.loading=true;
        var resource = this.$resource(this.url);
        resource.query(this.inputsellquery).then((res) => {
          if(res.data.Result>0){
              if(res.data.Result=='70001')this.$router.push('/login')
              this.$message.error(res.data.Message);
              this.inputsellquery.loading=false;
          }else{
              this.inputselllogs = JSON.parse(Base64.decode(res.data.Data));
              this.inputsellquery.row=parseInt(res.data.count);
              this.inputsellquery.loading=false;
          }
        }).catch((res) => {
              this.inputsellquery.loading=false;
        });
    },

    logspageSizeChange(val) {
        this.inputsellquery.rollpage = val;
        this.checkinventorylogdatas();
    },
    logspageCurrentChange(val) {
        this.inputsellquery.p = val;
        this.checkinventorylogdatas();
    },


    //获取品牌
    getBrand(){
      var resource = this.$resource(this.GLOBAL.domain+"Brand/index");
      resource.query({act:'lists',token:this.$cookies.get('token'),rollpage:1000}).then((res) => {
        if(res.data.Result>0){
          if(res.data.Result=='70001'){
            this.$router.push('/login')
          }
          this.$message.error(res.data.Message);
        }else{
          this.brandlists = JSON.parse(Base64.decode(res.data.Data));
        }
      }).catch((res) => {
          this.$message.error(this.GLOBAL.errortext);
      });
    },
    //获取仓库
    getWarehouse(){
      var resource = this.$resource(this.GLOBAL.domain+"Ware/index");
      resource.query({act:'lists',token:this.$cookies.get('token'),rollpage:1000}).then((res) => {
        if(res.data.Result>0){
          if(res.data.Result=='70001'){
            this.$router.push('/login')
          }
          this.$message.error(res.data.Message);
        }else{
          this.warehouselists = JSON.parse(Base64.decode(res.data.Data));
        }
      }).catch((res) => {
          this.$message.error(this.GLOBAL.errortext);
      });
    },
    //获取分类列表
    getCategoryList(){
      var resource = this.$resource(this.url);
      resource.query({ act:'getcategorylist',token:this.$cookies.get('token')}).then((res) => {
        if(res.data.Result>0){
          if(res.data.Result=='70001'){
            this.$router.push('/login')
          }
          this.$message.error(res.data.Message);
        }else{
          this.categorylist = JSON.parse(Base64.decode(res.data.Data));
        }
      }).catch((res) => {
          this.$message.error(this.GLOBAL.errortext);
      });
    },

    

    //信息列表
    getList(){       
      if(this.issearchchange==true) {
          this.query.p=1;
          this.query.rollpage=10;
      }
      if(Array.isArray(this.storage_location)&&this.storage_location.length>0){
        const last_item = this.storage_location[this.storage_location.length-1]
        this.query.storage_location=last_item
      }else{
        this.query.storage_location=''
      }
      this.listLoading = true;
      var resource = this.$resource(this.url);
      resource.query(this.query).then((res) => {
        if(res.data.Result>0){
          if(res.data.Result=='70001') this.$router.push('/login')
          this.$message.error(res.data.Message);
          this.listLoading = false;
        }else{
          this.lists = JSON.parse(Base64.decode(res.data.Data));
          this.total_rows=parseInt(res.data.count);
          this.listLoading = false;

          if(this.issearchchange==true) this.issearchchange=false;
          console.log(this.lists, 'SHANGPINKUCUN')
        }
      }).catch((res) => {
          this.$message.error(this.GLOBAL.errortext);
          this.listLoading=false;
      });
    },
    pageSizeChange(val) {
        this.query.rollpage = val;
        this.getList();
    },
    pageCurrentChange(val) {
        this.query.p = val;
        this.getList();
    },


    /** 获取销售记录信息列表 **/
    getsellslists(item) {
        alert(JSON.stringify(item));
    },

    
    /** 盘点 **/
    getmakeinventory() {
    	this.$router.push('/home/stockinventory');
    },

    /** 获取商品库存入库、出库信息 **/
    checkinventorylogs(item) {
        var _this=this;
        var warehouse=this.query.warehouse;
        var warehousename='';
        var productname=item.name;
        this.warehouselists.forEach(function(t,i) {if(t.id==warehouse) warehousename=t.name;});
        warehousename=='' ? productname+="  入库-销售记录" : productname +="（"+warehousename+"）  入库-销售记录";
        this.logname=productname;
        this.inputandsellDialog=true;

        this.inputsellquery.id='';
        this.inputsellquery.warehouse='';
        this.inputsellquery.p=1;
        this.inputsellquery.rollpage=10;
        this.inputsellquery.id=item.id;
        this.inputsellquery.warehouse=this.query.warehouse;
        this.inputdatas=[];
        this.leftloadingname='获取更多记录';
        this.sellslists=[];

        this.getinputandselllogs();
    },

    /** 获取更多入库记录 **/
    getmoreinputsells() {
        var _this=this;
        this.inputsellquery.p +=1;
        setTimeout(function() {
            _this.getinputandselllogs();
        },150);
    },

    /** 获取商品出入库库存信息列表 **/
    getinputandselllogs() {
        this.leftloadingname='拼命加载中...';
        var resource = this.$resource(this.url);
        resource.query(this.inputsellquery).then((res) => {
          if(res.data.Result>0){
              if(res.data.Result=='70001')this.$router.push('/login')
              this.$message.error(res.data.Message);
              this.leftloadingname='没有更多记录';
          }else{
              var result = JSON.parse(Base64.decode(res.data.Data));
              result.length > 0 ? this.leftloadingname='获取更多记录' : this.leftloadingname="没有更多记录";
              var _this=this;
              if(result.length > 0) {
                  result.forEach(function(item,i) {
                      _this.inputdatas.push(item);
                  });
              }
          }
        }).catch((res) => {
              this.$message.error(this.GLOBAL.errortext);
        });
    },

    /** 获取出库明细 **/
    getsellslists(item) {
        if(item.id==this.sellsquery.id && this.sellsquery.length > 0) {this.$message.error("该条记录的出库明细已展示在右边");return false;}
        this.sellsquery.inputid='';
        this.sellsquery.p=1;
        this.sellsquery.rollpage=10;
        this.sellsquery.inputid=item.id;
        this.sellslists=[];
        this.rightloadingname='获取更多记录';
        this.getsellsdata();
    },

    /** 获取更多出库明细 **/
    getmoresells() {
        var _this=this;
        this.sellsquery.p +=1;
        setTimeout(function() {
            _this.getsellsdata();
        },150);
    },

    /** 获取出库明细信息数据 **/
    getsellsdata() {
        this.rightloadingname='拼命加载中...';
        var resource = this.$resource(this.url);
        resource.query(this.sellsquery).then((res) => {
          if(res.data.Result>0){
              if(res.data.Result=='70001')this.$router.push('/login')
              this.$message.error(res.data.Message);
              this.rightloadingname="没有更多记录";
          }else{
              var result = JSON.parse(Base64.decode(res.data.Data));
              result.length > 0 ? this.rightloadingname="获取更多记录" : this.rightloadingname="没有更多记录";
              var _this=this;
              if(result.length > 0) {
                  result.forEach(function(item,i) {
                      _this.sellslists.push(item);
                  });
              }
          }
        }).catch((res) => {
              this.$message.error(this.GLOBAL.errortext);
        });
    },

    /** 获取报告销售情况 **/
    getreport(item) {
        this.iasreportDialog=true;
        var resource = this.$resource(this.url);
        resource.query({act:'getinputsellsreport',inputid:item.id,type:'single',token:this.$cookies.get('token')}).then((res) => {
          if(res.data.Result>0){
              if(res.data.Result=='70001')this.$router.push('/login')
              this.$message.error(res.data.Message);
          }else{
              var result = JSON.parse(Base64.decode(res.data.Data));
              this.reportdatas=result;
          }
        }).catch((res) => {
            this.$message.error(this.GLOBAL.errortext);
        });
    },

    /** 获取总报告 **/
    getallreport() {
        this.iasreportDialog=true;
        var resource = this.$resource(this.url);
        resource.query({act:'getinputsellsreport',inputid:this.inputsellquery.id,warehouse: this.inputsellquery.warehouse,type:'all',token:this.$cookies.get('token')}).then((res) => {
          if(res.data.Result>0){
              if(res.data.Result=='70001')this.$router.push('/login')
              this.$message.error(res.data.Message);
          }else{
              var result = JSON.parse(Base64.decode(res.data.Data));
              this.reportdatas=result;
          }
        }).catch((res) => {
            this.$message.error(this.GLOBAL.errortext);
        });
    },

    /** 导出库存商品信息 **/
    exportdata() {
        this.exportDialog=true;
        this.exportloading=true;
        var resource = this.$resource(this.GLOBAL.exportUrl+"Inventory/index");
        resource.query({act:'getinventorylists',token:this.$cookies.get('token'),brandid:this.query.brandid,key:this.query.key}).then((res) => {
          if(res.data.Result>0){
              if(res.data.Result=='70001') this.$router.push('/login')
              this.$message.error(res.data.Message);
                  this.exportloading=false;
          }else{
              const tempLists = JSON.parse(Base64.decode(res.data.Data));
              console.log(tempLists, 'pppppppp')
              if(Array.isArray(tempLists)&&tempLists.length>0){
                for (const element of tempLists) {
                   if(Array.isArray(element.storage_location)&&element.storage_location.length>0){
                      let storage_location_text = ""
                      for (const element_ of element.storage_location) {
                        storage_location_text = `${storage_location_text}${element_.full_code} <span style="color: red;">(${element_.available_number})</span>;<br />`
                      }
                      element.storage_location_text=storage_location_text
                   }else{
                     element.storage_location_text=""
                   }             
                }
              }
              this.exportlists = tempLists
              this.exportloading=false;
              console.log(this.exportlists)
          }
        }).catch((res) => {
            this.exportloading=false;
        });
    },

    sureoutput() {
        function formatJson(filterVal, jsonData, transformFn) {
          return jsonData.map(v => filterVal.map(j => {
            let value = v[j];
            if (transformFn) {
                value = transformFn(value, j);
            }
            return value;
          }));
        }
        require.ensure([], () => {
            var { export_json_to_excel } = require('../../vendor/Export2Excel');
            var tHeader = ['编号','商品名称','条形码','规格','单位','箱装规格','品牌','批发价（基本单位）','零售价（基本单位）','库存','可用库存'];
            var filterVal = ['number','name','basebarcode','spec','unit','box_gauge','companyname','sell','market','inventory','lastinventory'];
            if(this.goodsLocationStatus){
              tHeader.push("货位")
              filterVal.push("storage_location")
            }
            var list = this.exportlists;
            // / 格式化数据，处理数组换行
            var data = formatJson(filterVal, list, (value, key) => {
                if (key === 'storage_location' && Array.isArray(value)) {
                    // 如果是数组，将每个对象转换为 "full_code（available_number）" 的格式，并用换行符连接
                    return value.map(item => `${item.full_code}（${item.available_number}）`).join('\r\n');
                }
                return value;
            });
            // var data = this.formatJson(filterVal, list);
            export_json_to_excel(tHeader, data, '商品库存记录');
            this.exportDialog=false;
        })
    },

    //导出表格数据
	  formatJson(filterVal, jsonData) {
　　　　return jsonData.map(v => filterVal.map(j => v[j]));
　　},


    //查看冻结库存
    showfrozeninventory(item) {
       this.$emit('listenchild',{name:'查看冻结库存',url:'Showfrozen',data:{id:item.id}});
    },

    //查看库存预售情况
    showsalefulture() {
      this.$emit('listenchild',{name:'查看库存预售',url:'showsalefulture'});
    },


    //查看商品的冻结库存信息
    getfrozeninventorys(item) {
        this.$emit('listenchild',{name:'查看冻结库存',url:'Showfrozen',data:{goodsinfo:item}});
    },
    checkLocationStatus(){
      const goodsLocationStatus = localStorage.getItem("storageLocationStatus")||''
      if(goodsLocationStatus == "true"){
        this.goodsLocationStatus=true
      }else{
        this.goodsLocationStatus=false
      }      
    },
    resetSearchParams(){
      this.issearchchange=true
      this.storage_location=[]
      this.query.storage_location=''
      if(this.goodsLocationStatus){
        this.locationDropdownList()
      }
    },
    locationDropdownList(){
      const address_url = this.GLOBAL.domain+"StorageLocation/cascade_tree"
      const send_data = {warehouse_id:this.query.warehouse,token:this.$cookies.get('token')}
      var resource = this.$resource(address_url);
      resource.save(send_data).then((res) => {
        if(res.data.Result>0){
            this.locationList = []
            this.$message.error(res.data.Message);
        }else{
            var result = JSON.parse(Base64.decode(res.data.Data));
            this.locationList = result
            console.log(result)
        }
      }).catch((res) => {
          this.locationList = []
          this.$message.error(this.GLOBAL.errortext);
      });
    }

  }
}
</script>
<style>
.flex-warp {
  display: flex;
  justify-content: space-around;
  align-items: center;
}
.backborder1 {background:#fff;border-radius:15px;border:1px solid #ddd;padding:1% 1% 0 1%}
.backborder2 {background:#fff;border-radius:15px;border:1px solid #ddd;padding:0 1% 3% 1%}
.allreport {float:left;padding:1px 5px 1px 5px;line-height:1.5rem;background:#E6A23C;border:0;border-radius:6px;color:#fff;text-decoration:none}
.inputs,.sells {float:left;width:47.3%;padding:1% 1% 1% 1%;height:420px;border-right:1px solid #ddd;border-color:rgb(255,255,255,.7);border-radius: 6px 0 0 6px;background:rgb(221,221,221,.3);overflow:auto}
.inputs table,.sells table {float:left;width:100%}
.inputs tr:hover {background:rgb(255,255,255,.7);}
.inputs table tr td,.sells table tr td {padding:10px 0 10px 0;border-bottom:1px solid #fff;color:#606266}
.inputs table th,.sells table th {color:#909399;border-bottom:1px solid #fff;padding:10px 0 10px 0}
.inputs .report {padding:1px 3px 1px 3px;background:#E6A23C;border:0;border-radius:6px;color:#fff;text-decoration:none}
.inputsmorelog {float:left;width:100%;margin-top:20px;padding:2px 0 2px 0;color:#606266;text-align:center}
.inputsmorelog a {color:#606266;text-decoration:none}

.cz-product-inventorys-main {display:inline-block;width:100%}
.cz-product-inventorys-main-imgs {float:left;width:70px;height:70px;border-radius:6px;background:rgba(221,221,221,.3);border:1px solid rgba(221,221,221,.7);display:flex;justify-content:center;align-items:center;}
.cz-product-inventorys-main-imgs img {border-radius:6px;max-width:100%;max-height:100%;}
.cz-product-inventorys-main-infos {float:left;width:calc(100% - 70px - 2px - 10px);height:60px;margin-left:10px;}
.cz-product-inventorys-main-infos-name {float:left;width:100%;font-size:13px;line-height:21px;color:#666666;overflow:hidden;white-space: nowrap;text-overflow: ellipsis;}
.cz-product-inventorys-main-infos-number {float:left;width:100%;font-size:12px;line-height:21px;color:#999999;overflow:hidden;white-space: nowrap;text-overflow: ellipsis;}

.cz-product-inventorys {width:100%;display:flex;justify-content:left;align-items:center;}
.cz-product-inventorys img {float:left;width:20px;height:20px;}
.cz-product-inventorys-value {float:left;width:calc(100% - 20px - 10px);margin-left:10px;font-size:13px;text-align:center;}


.sells {float:left;width:47.3%;padding:1% 1% 1% 1%;height:420px;border-radius:0 6px 6px 0;background:rgb(221,221,221,.3)}

/*滚动条样式*/
.inputs::-webkit-scrollbar,.sells::-webkit-scrollbar {width: 2px;height: 2px;}
.inputs::-webkit-scrollbar-thumb,.sells::-webkit-scrollbar-thumb {border-radius: 15px;-webkit-box-shadow: inset 0 0 0 rgba(0,0,0,0.2);background: rgba(0,0,0,0.2);}
.inputs::-webkit-scrollbar-track,.sells::-webkit-scrollbar-track {-webkit-box-shadow: inset 0 0 0 rgba(0,0,0,0.2);border-radius: 0;background: rgba(0,0,0,0.1);}

</style>


// WEBPACK FOOTER //
// src/components/inventory/Lists.vue